import React from "react";
import { Box, Typography } from "@mui/material";

const BillingPageFrame = ({ title, subtitle, children, maxWidth = 1100 }) => (
    <Box sx={{ py: 2, maxWidth }}>
        <Typography variant="h5" sx={{ fontWeight: 800, letterSpacing: "-0.02em", mb: 0.5 }}>
            {title}
        </Typography>
        {subtitle && (
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2.5 }}>
                {subtitle}
            </Typography>
        )}
        {children}
    </Box>
);

export default BillingPageFrame;
